import React from 'react'
import './Footer.css'
import { Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

const Footer = () => {
    const { loginWithRedirect, logout, isAuthenticated } = useAuth0();
    const year = new Date().getFullYear();

    return (
        <div className='footer'>
            <div className='footerBody'>
                <div className='footerElem'>
                    <h2>MyEmployeeManual.com</h2>
                    <p>A starting point for your compliance program.</p>
                    <br />
                    <Link to='/' className='footerLink'><p>Home</p></Link>
                    <Link to='/contact' className='footerLink'><p>Contact Us</p></Link>
                    <button onClick={() => isAuthenticated ? logout() : loginWithRedirect()} className='tab'><p>{isAuthenticated ? "Sign Out" : "Sign In"}</p></button>
                </div>
                <div className='footerElem'>
                    <h3>Contact Us</h3>
                    <p>Phone: +1 562-302-7483</p>
                    <p>Email: support@myemployeemanual.com</p>
                    <Link to='/contact' className='footerLink'>Contact Form</Link>
                </div>
            </div>
            <div className='footerDisclaimer'>
                <p>
                    MyEmployeeManual.com is not a law firm and does not provide legal advice.
                    Generated documents are starting points for compliance — review with licensed counsel before adopting.
                    Your data is encrypted in transit and at rest.
                </p>
            </div>
            <div className='footerFooter'>
                <p className='leadingText'>© {year} MyEmployeeManual.com. All rights reserved.</p>
                <div className='links'>
                    <Link to="/privacyPolicy" className="footerLink">Privacy Policy</Link>
                    <span> | </span>
                    <Link to="/tos" className="footerLink">Terms of Service</Link>
                    <span> | </span>
                    <Link to="/do-not-sell-or-share" className="footerLink">Do Not Sell or Share My Personal Information</Link>
                    <span> | </span>
                    <Link to="/subprocessors" className="footerLink">Subprocessors</Link>
                </div>
            </div>
        </div>
    );
}

export default Footer;
